import styled from "styled-components";

const ErrorCard = ({ errorObj }) => {
  let isEmpty = Object.values(errorObj).every((x) => x === null || x === "");
  return (
    <>
      {!isEmpty && (
        <ErrorContainer>
          {Object.keys(errorObj).map((key) => (
            <ErrorHelperText>
              {errorObj?.[key] && <span>{errorObj?.[key]}</span>}
            </ErrorHelperText>
          ))}
        </ErrorContainer>
      )}
    </>
  );
};

const ErrorContainer = styled.div`
  flex: 1;
  width: 100%;
  padding: 1rem;
  background: #ff00000a;
  border: 1px solid red;
  box-sizing: border-box;
  border-radius: 0.5rem;
`;
const ErrorHelperText = styled.div`
  font-size: 0.75rem;
  color: red;
  >span::before{
    content:"• "
  }
`;

export default ErrorCard;
